<template>
<div class="chapter">
<div class="inner_page">
<p><a id="TOC"></a></p>
<div class="ContentsPage">
<h1>Contents</h1>
<p><a href="#/Text/APRE">Author’s preface</a></p>
<p><a href="#/Text/ABR">Chief abbreviations</a></p>
<p><a href="#/Text/INT">Introduction</a></p>
<p>1. <a href="#/Text/CH1">The perfect church (1:1–9)</a></p>
<p>2. <a href="#/Text/CH2">Cliques at Corinth (1:10–17)</a></p>
<p>3. <span href="#/Text/CH3" title="Link target outside of Sample">Wisdom—true and false (1:18–2:16)</span></p>
<p>4. <span href="#/Text/CH4" title="Link target outside of Sample">Fools for Christ’s sake (3:1–4:21)</span></p>
<p>5. <span href="#/Text/CH5" title="Link target outside of Sample">Flee fornication (5:1–13; 6:9–20)</span></p>
<p>6. <span href="#/Text/CH6" title="Link target outside of Sample">Settled out of court (6:1–8)</span></p>
<p>7. <span href="#/Text/CH7" title="Link target outside of Sample">Marriage and singleness—two gifts from God (7:1–40)</span></p>
<p>8. <span href="#/Text/CH8" title="Link target outside of Sample">Freedom and sensitivity to others (8:1–13)</span></p>
<p>9. <span href="#/Text/CH9" title="Link target outside of Sample">Freedom to restrict our freedom (9:1–27)</span></p>
<p>10. <span href="#/Text/CH10" title="Link target outside of Sample">Freedom and its dangers (10:1–11:1)</span></p>
<p>11. <span href="#/Text/CH11" title="Link target outside of Sample">The Christian community at worship (11:2–34)</span></p>
<p>12. <span href="#/Text/CH12" title="Link target outside of Sample">Concerning spiritual gifts (12:1–31)</span></p>
<p>13. <span href="#/Text/CH13" title="Link target outside of Sample">If I have not love … (13:1–13)</span></p>
<p>14. <span href="#/Text/CH14" title="Link target outside of Sample">Prophecy and tongues (14:1–40)</span></p>
<p>15. <span href="#/Text/CH15" title="Link target outside of Sample">Resurrection—past, present and future (15:1–58)</span></p>
<p>16. <span href="#/Text/CH16" title="Link target outside of Sample">An international church (16:1–24)</span></p>
<p><span href="#/Text/STG" title="Link target outside of Sample">Study Guide</span></p>
<p><span href="#/Text/Notes" title="Link target outside of Sample">Notes</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TOC.vue?6777ace2